import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import propTypesHelper from 'helpers/proptypes';
import utils from 'helpers/utils';

class ComponentToggle extends React.Component {
    render() {
        const { children, record, resource, validatedSource } = this.props;

        let value = record[validatedSource];

        if (utils.isUndefined(value)) {
            return null;
        }

        let child = children[1];

        if (value) {
            child = children[0];
        }

        const element = React.cloneElement(
            child,
            Object.assign({}, child.props, {
                record: record,
                resource: resource,
            })
        );

        return (
            <span>{ element }</span>
        );
    }
}

ComponentToggle.propTypes = {
    children: PropTypes.oneOfType([
        propTypesHelper.arrayIsEqualTo(2),
        PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    record: PropTypes.object,
    resource: PropTypes.string,
    validatedSource: PropTypes.string.isRequired,
};

export default pure(ComponentToggle);



// WEBPACK FOOTER //
// ./src/components/list/Toggle/ComponentToggle.js